

































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
    mdbBtn,
    mdbIcon,
    mdbTooltip,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbMask,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbAlert,
    mdbBadge,
    mdbPopover
} from '@folky-tools/mdbvue';
import {
    usersService,
    businessFrontPagesService,
    businessesService,
    companiesService,
    businessPaymentOptionsService,
    businessBookingOptionsService,
    businessSellingOptionsService,
    referencesClassificationService,
    enableBusinessFrontPageSlugService,
    disableBusinessFrontPageSlugService,
    unpublishBusinessFrontPageService,
    notificationsService,
    updateOrganizationBusinessUrlQrPageRedirectsTo,
    UpdateOrganizationBusinessUrlQrPageRedirectsToDto,
    getOrganizationBusinessFrontPageSummaryByBusinessId
} from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Business } from '@/models/businesses/business';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';
import { BusinessPaymentOptionsSummary } from '@/models/businesses/business-payment-options-summary';
import { ClassificationSummary } from '@/models/references-classification/classification-summary';
import { BusinessBookingOptions } from '@/models/businesses/business-booking-options';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';
import { Company } from '@/models/companies/company';
import Swal from 'sweetalert2';
import { LinkType } from '@/models/common/link';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbCardUp,
        mdbCardAvatar,
        mdbCardGroup,
        mdbView,
        mdbMask,
        mdbDropdown,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbDropdownItem,
        mdbAlert,
        mdbBadge,
        mdbPopover,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        CompanyData: () => import('@/components/companies/CompanyData.vue'),
        FrontPageLinksToConsumers: () => import('@/components/shared/FrontPageLinksToConsumers.vue'),
        TeaserCardLinksToConsumers: () => import('@/components/shared/TeaserCardLinksToConsumers.vue'),
        EditFrontPageSlug: () => import('@/components/shared/EditSlug.vue'),
        EditConsumerQr: () => import('@/components/shared/EditConsumerQr.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessDashboardView extends Vue {
    private business: Business = new Business();
    private businessCompany: Company = new Company();
    private businessCompanyCopy: Company = new Company();
    private businessFrontPageSummary: BusinessFrontPageSummary = new BusinessFrontPageSummary();
    private businessPaymentOptionsSummary: BusinessPaymentOptionsSummary = new BusinessPaymentOptionsSummary();
    private businessReferencesClassificationSummary: ClassificationSummary = new ClassificationSummary();
    private businessBookingOptions: BusinessBookingOptions = new BusinessBookingOptions();
    private businessSellingOptions: BusinessSellingOptions = new BusinessSellingOptions();
    private businessContactSettingsSummary: {} = { visible: false };
    private businessFrontPageSlug?: string = '';
    private selectedConsumerQrRedirectionUrl: string | undefined = '';
    private selectedConsumerId: number = 0;
    private selectedConsumerName: string = '';

    private showEditBillingData: boolean = false;
    private showEditFrontPageSlug: boolean = false;
    private showEditConsumerQr: boolean = false;

    private savingBillingData: boolean = false;
    private savingFrontPageSlug: boolean = false;
    private savingConsumerQr: boolean = false;

    private pageContentLoaded: boolean = false;

    private publishingBusiness: boolean = false;
    private unpublishingBusiness: boolean = false;
    private publishingFrontpage: boolean = false;
    private unpublishingFrontpage: boolean = false;

    private frontPageCardImage: string = '';

    get externalLinksThatAreSocialMediaOrContactWebsiteWithValue() {
        return this.business.externalLinks.filter(l => l.url && l.type !== LinkType.Other);
    }

    private async created(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessDashboardView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        const businessId = this.getBusinessIdFromRouteParamsWithoutNaNError();

        this.business = await businessesService.getBusiness(businessId);
        this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(businessId));
        this.businessFrontPageSlug = this.businessFrontPageSummary.slug;

        this.setFrontPageCardImage();

        this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);

        if (this.business.companyId) {
            this.businessCompany = await companiesService.getCompany(this.business.companyId!);
            this.businessCompanyCopy = this.businessCompany.clone();
        }

        this.businessPaymentOptionsSummary = await businessPaymentOptionsService.getPaymentOptionsSummary(this.business.id);
        this.businessBookingOptions = await businessBookingOptionsService.getBookingOptions(this.business.id);
        this.businessSellingOptions = await businessSellingOptionsService.getSellingOptions(this.business.id);
        this.businessReferencesClassificationSummary = await referencesClassificationService.getClassificationSummary(this.business.id);
        this.businessContactSettingsSummary = await businessesService.getBusinessFrontPageFormConfigSummary(this.business.id);

        this.pageContentLoaded = true;

        this.reorderMasonryBlocks();
    }

    private async mounted(): Promise<void> {
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.Dashboard,
                entityId: this.business.id
            })
        );
    }

    private reorderMasonryBlocks(): void {
        setTimeout(() => (this as any).$redrawVueMasonry(), 100);
    }

    private getBusinessIdFromRouteParamsWithoutNaNError(): number {
        return +this.$route.params.id;
    }

    get logoUrl(): string {
        if (this.business.logoUrl) {
            return this.business.logoUrl;
        } else {
            const imagesContext = require.context('@/assets/placeholders/business/', false, /(\.jpg|\.png)$/);
            return imagesContext('./whiteBrandLogoDark.png');
        }
    }

    // #region EDIT BILLING DATA

    private editBusinessBillingData(): void {
        this.showEditBillingData = true;
    }

    private async saveBusinessBillingData(): Promise<void> {
        this.savingBillingData = true;

        if ((this.$refs.businessBillingData as any).hasErrors()) {
            this.savingBillingData = false;
            return;
        }

        try {
            const updateResult = await businessesService.updateBusinessCompany(this.business.id, this.businessCompany);
            if (updateResult.result) {
                this.business.companyId = updateResult.id;
                this.showEditBillingData = false;

                notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.editBillingData.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.BillingData,
                        entityId: this.business.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBillingData = false;
        }
    }

    private closeBusinessBillingDataEdition(): void {
        this.businessCompany = this.businessCompanyCopy.clone();
        this.showEditBillingData = false;
    }

    // #endregion EDIT BILLING DATA

    // #region EDIT SLUG

    private editFrontPageSlug(): void {
        this.showEditFrontPageSlug = true;
    }

    private async saveFrontPageSlug(): Promise<void> {
        this.savingFrontPageSlug = true;

        const editSlugElement: any = this.$refs.editSlug;

        if (editSlugElement.hasErrors()) {
            this.savingFrontPageSlug = false;
            return;
        }

        try {
            if (!(await businessFrontPagesService.checkIfBusinessFrontPageSlugExists(+this.$route.params.id, this.businessFrontPageSlug!))) {
                if (await businessFrontPagesService.updateBusinessFrontPageSlug(+this.$route.params.id, this.businessFrontPageSlug!)) {
                    this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));

                    this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);

                    this.closeFrontPageSlugEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.notifications.slugUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.Slug,
                            entityId: this.business.id
                        })
                    );

                    return;
                }
                notificationsService.showToastErrorNotification();
            } else {
                notificationsService.showToastErrorNotification('views.businesses.businessDashboardView.notifications.slugExists');
                return;
            }
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageSlug = false;
        }
    }

    private closeFrontPageSlugEdition(): void {
        this.businessFrontPageSlug = this.businessFrontPageSummary.slug;
        this.showEditFrontPageSlug = false;
    }

    private async enableFrontPageSlug(): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.publishModal.title').toString(),
            html: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.publishModal.html').toString(),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.publishModal.confirmButtonText').toString(),
            cancelButtonText: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.publishModal.cancelButtonText').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });
        if (questionResult.value) {
            try {
                this.publishingFrontpage = true;
                if (await enableBusinessFrontPageSlugService.execute(+this.$route.params.id)) {
                    notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.notifications.frontPageSuccessfullyPublished');

                    this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));
                    this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);
                    this.reorderMasonryBlocks();

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.SlugAvailability,
                            entityId: this.business.id
                        })
                    );
                } else {
                    notificationsService.showToastErrorNotification();
                }
            } catch {
                notificationsService.showToastErrorNotification();
            } finally {
                this.publishingFrontpage = false;
            }
        }
    }

    private async disableFrontPageSlug(): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.unPublishModal.title').toString(),
            html: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.unPublishModal.html').toString(),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.unPublishModal.confirmButtonText').toString(),
            cancelButtonText: this.$t('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.unPublishModal.cancelButtonText').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });
        if (questionResult.value) {
            this.unpublishingFrontpage = true;
            try {
                const disableSlugResponse = await disableBusinessFrontPageSlugService.execute(+this.$route.params.id, true);
                if (disableSlugResponse.result) {
                    notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.notifications.frontPageSuccessfullyUnpublished');

                    this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));
                    this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);
                    this.reorderMasonryBlocks();

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.SlugAvailability,
                            entityId: this.business.id
                        })
                    );
                } else if (disableSlugResponse.hasPublishedReferences) {
                    notificationsService.showToastErrorNotification('views.businesses.businessDashboardView.publicationStatus.frontPagePublication.notifications.businessHasReferencesPublished');
                } else {
                    notificationsService.showToastErrorNotification();
                }
            } catch {
                notificationsService.showToastErrorNotification();
            } finally {
                this.unpublishingFrontpage = false;
            }
        }
    }

    // #endregion EDIT SLUG

    // #region PUBLISH/UNPUBLISH BUSINESS

    private async prePublish(): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$t('views.businesses.businessDashboardView.actions.publish.modal.title').toString(),
            html: this.businessFrontPageSummary.hasSlug
                ? this.$i18n
                      .t('views.businesses.businessDashboardView.actions.publish.modal.content.hasSlugHtml')
                      .toString()
                      .replace('{0}', this.businessFrontPageSummary.publicationStatus.map(ps => ps.consumerName).join('<br/>'))
                : this.$i18n
                      .t('views.businesses.businessDashboardView.actions.publish.modal.content.missingSlugHtml')
                      .toString()
                      .replace('{0}', this.businessFrontPageSummary.publicationStatus.map(ps => ps.consumerName).join('<br/>')),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('views.businesses.businessDashboardView.actions.publish.modal.doConfirm').toString(),
            cancelButtonText: this.$t('views.businesses.businessDashboardView.actions.publish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });
        if (questionResult.value) {
            await this.publish();
        }
    }

    private async publish(): Promise<void> {
        try {
            this.publishingBusiness = true;
            if (await businessFrontPagesService.publishBusinessFrontPage(+this.$route.params.id)) {
                this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));
                this.businessFrontPageSlug = this.businessFrontPageSummary.slug;

                this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);

                if (this.businessFrontPageSummary.hasSlug) {
                    notificationsService.showToastSuccessNotification(this.$t('views.businesses.businessDashboardView.notifications.businessPublishedSuccess.hasSlug').toString());
                } else {
                    notificationsService.showToastSuccessNotification(this.$t('views.businesses.businessDashboardView.notifications.businessPublishedSuccess.missingSlug').toString());
                }

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.Publication,
                        entityId: this.business.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.publishingBusiness = false;
        }
    }

    private async unpublish(): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$t('views.businesses.businessDashboardView.actions.unpublish.modal.title').toString(),
            html: this.$t('views.businesses.businessDashboardView.actions.unpublish.modal.html').toString(),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('views.businesses.businessDashboardView.actions.unpublish.modal.confirmButtonText').toString(),
            cancelButtonText: this.$t('views.businesses.businessDashboardView.actions.unpublish.modal.cancelButtonText').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });
        if (questionResult.value) {
            this.unpublishingBusiness = true;
            try {
                const unpublishResponse = await unpublishBusinessFrontPageService.execute(+this.$route.params.id);
                if (unpublishResponse.result) {
                    notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.notifications.businessUnpublishedSuccess');

                    this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));
                    this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.Publication,
                            entityId: this.business.id
                        })
                    );
                } else if (unpublishResponse.hasPublishedFrontPage) {
                    notificationsService.showToastErrorNotification('views.businesses.businessDashboardView.notifications.businessUnpublishedError.businessHasFrontpagePublished');
                } else if (unpublishResponse.hasPublishedReferences) {
                    notificationsService.showToastErrorNotification('views.businesses.businessDashboardView.notifications.businessUnpublishedError.businessHasReferencesPublished');
                } else {
                    notificationsService.showToastErrorNotification();
                }
            } catch {
                notificationsService.showToastErrorNotification();
            } finally {
                this.unpublishingBusiness = false;
            }
        }
    }

    // #endregion PUBLISH BUSINESS

    // #region EDIT CONSUMER QR
    private onShowEditConsumerQrModal(consumerId: number, consumerName: string): void {
        this.selectedConsumerQrRedirectionUrl = this.business.urlsQrPagesRedirectTo.find(qr => qr.consumerId === consumerId)!.urlQrPageRedirectsTo;
        this.selectedConsumerId = consumerId;
        this.selectedConsumerName = consumerName;
        this.showEditConsumerQr = true;
    }

    private async saveConsumerQr(): Promise<void> {
        this.savingConsumerQr = true;
        const skuSerialValidationInput: UpdateOrganizationBusinessUrlQrPageRedirectsToDto = new UpdateOrganizationBusinessUrlQrPageRedirectsToDto(this.business.id, this.selectedConsumerId, this.selectedConsumerQrRedirectionUrl!);
        try {
            await updateOrganizationBusinessUrlQrPageRedirectsTo.execute(skuSerialValidationInput);
            this.business.urlsQrPagesRedirectTo.find(qr => qr.consumerId === this.selectedConsumerId)!.urlQrPageRedirectsTo = this.selectedConsumerQrRedirectionUrl;
            this.closeConsumerQrEdition();
            notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.notifications.qrRedirectionUrlUpdateSuccess');
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingConsumerQr = false;
        }
    }

    private closeConsumerQrEdition(): void {
        this.showEditConsumerQr = false;
    }
    // #endregion EDIT CONSUMER QR

    private setFrontPageCardImage(): void {
        const imagesContextShared = require.context('@/assets/placeholders/shared/', false, /(\.jpg|\.png)$/);

        this.frontPageCardImage = this.businessFrontPageSummary.mainImageUrl ? this.businessFrontPageSummary.mainImageUrl : imagesContextShared('./placeholder16x9.png');
    }
}
